module.exports = __webpack_public_path__ + "static/relationship-78a8a12857a15c3d473f59970362f910.jpg";